export default "__VITE_ASSET__CVaEEZvm__"